import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { Clock, DollarSign, CheckCircle } from 'lucide-react';
import type { PayrollData } from './PayrollTypes';

interface PayrollSummaryCardsProps {
  payrollData: PayrollData[];
}

export const PayrollSummaryCards: React.FC<PayrollSummaryCardsProps> = ({ payrollData }) => {
  const totalGrossPay = payrollData.reduce((sum, emp) => sum + emp.gross_pay, 0);
  const totalNetPay = payrollData.reduce((sum, emp) => sum + emp.net_pay, 0);
  const totalHours = payrollData.reduce((sum, emp) => sum + emp.total_hours, 0);

  return (
    <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6">
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-2">
            <Clock className="h-4 w-4 text-blue-500" />
            <div>
              <p className="text-sm text-muted-foreground">Total Hours</p>
              <p className="text-2xl font-bold">{totalHours.toFixed(1)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-2">
            <DollarSign className="h-4 w-4 text-green-500" />
            <div>
              <p className="text-sm text-muted-foreground">Gross Pay</p>
              <p className="text-2xl font-bold">${totalGrossPay.toFixed(2)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-2">
            <DollarSign className="h-4 w-4 text-blue-500" />
            <div>
              <p className="text-sm text-muted-foreground">Net Pay</p>
              <p className="text-2xl font-bold">${totalNetPay.toFixed(2)}</p>
            </div>
          </div>
        </CardContent>
      </Card>
      
      <Card>
        <CardContent className="p-4">
          <div className="flex items-center gap-2">
            <CheckCircle className="h-4 w-4 text-orange-500" />
            <div>
              <p className="text-sm text-muted-foreground">Employees</p>
              <p className="text-2xl font-bold">{payrollData.length}</p>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};